import { render, staticRenderFns } from "./CircleCloseButton.vue?vue&type=template&id=637da72a"
import script from "./CircleCloseButton.vue?vue&type=script&lang=js"
export * from "./CircleCloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports